<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :config-module="configModule"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'

export default {
  name: 'FclAddonDataGrid',
  components: {
  },
  props: {
    configModule: { type: String, default: '', required: true },
    showCreate: { type: Boolean, default: false },
    showModify: { type: Boolean, default: false },
    showApprove: { type: Boolean, default: false },
    showSelection: { type: Boolean, default: false },
    gridOptions: { type: Object, default: () => {} },
    rowData: { type: Array, default: () => [] }
  },
  data() {
    return {
      tenantUtil: {},
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: ' ', maxWidth: 30, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          hide: !this.showSelection, suppressColumnsToolPanel: !this.showSelection,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Pricing.POL'), field: 'pol', colId: 'pol', width: 200,
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value,
              'englishName')
          }
        },
        {
          headerName: this.$t('Pricing.POD'), field: 'pod', colId: 'pod', width: 200,
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value,
              'englishName')
          }
        },
        {
          headerName: this.$t('Pricing.Currency'), field: 'currency', colId: 'currency', width: 200
        },
        {
          headerName: this.$t('Pricing.CostPrice') + '(TON)', field: 'costWeightPrice', colId: 'costWeightPrice', width: 85,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.CostPrice') + '(CBM)', field: 'costVolumePrice', colId: 'costVolumePrice', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.CostPrice') + '(MIN)', field: 'minimumTonCost', colId: 'minimumTonCost', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.ColoaderPrice') + '(TON)', field: 'oneWeightPrice', colId: 'oneWeightPrice', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.ColoaderPrice') + '(CBM)', field: 'oneVolumePrice', colId: 'oneVolumePrice', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.ColoaderPrice') + '(MIN)', field: 'minimumTonPrice1', colId: 'minimumTonPrice1', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.CustomerPrice') + '(TON)', field: 'twoWeightPrice', colId: 'twoWeightPrice', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.CustomerPrice') + '(CBM)', field: 'twoVolumePrice', colId: 'twoVolumePrice', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.CustomerPrice') + '(MIN)', field: 'minimumTonPrice2', colId: 'minimumTonPrice2', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.MarketPrice') + '(TON)', field: 'threeWeightPrice', colId: 'threeWeightPrice', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.MarketPrice') + '(CBM)', field: 'threeVolumePrice', colId: 'threeVolumePrice', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.MarketPrice') + '(MIN)', field: 'minimumTonPrice3', colId: 'minimumTonPrice3', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.Carrier'), field: 'carrier', colId: 'carrier', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.companyShortNameLabelFun(params.value)
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Pricing.ShippingLine'),
          field: 'shippingLine',
          colId: 'shippingLine',

          width: 200
        },
        {
          headerName: this.$t('Pricing.DaysColSea'),
          field: 'days',
          colId: 'days',
          width: 200
        },
        { headerName: this.$t('Pricing.PriceDateType'), field: 'priceDateType', colId: 'priceDateType', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.priceDateTypeColumnLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.Branch'),
          field: 'branchId',
          colId: 'branchId',
          width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'code')
          }
        },
        {
          headerName: this.$t('Pricing.CreatedBy'),
          field: 'createdBy',
          colId: 'createdBy',
          width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.CreatedDate'),
          field: 'dateCreated',
          colId: 'dateCreated',
          width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        {
          headerName: this.$t('Pricing.ModifiedBy'),
          field: 'modifiedBy',
          colId: 'modifiedBy',
          width: 200,
          hide: !this.showModify, suppressColumnsToolPanel: !this.showModify,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.ModifiedDate'),
          field: 'dateModified',
          colId: 'dateModified',
          width: 200,
          hide: !this.showModify, suppressColumnsToolPanel: !this.showModify,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.ApprovedBy'),
          field: 'approvedBy',
          colId: 'approvedBy',
          width: 200,
          hide: !this.showApprove, suppressColumnsToolPanel: !this.showApprove,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          }
        },
        { headerName: this.$t('Pricing.ApprovedDate'), field: 'dateApproved', colId: 'dateApproved', width: 200,
          hide: !this.showApprove, suppressColumnsToolPanel: !this.showApprove,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.Remarks'),
          field: 'remarks',
          colId: 'remarks',
          width: 200,
          cellRenderer: (params) => {
            return PriceUtils.remarkLabelFunc(params.data, params.value)
          }
        },
        {
          headerName: this.$t('Pricing.volumeWeightRatio'),
          field: 'volumeWeightRatio',
          colId: 'volumeWeightRatio',
          width: 200
        },
        {
          headerName: this.$t('Pricing.minRateValue'),
          field: 'minRateUnit',
          colId: 'minRateUnit',
          width: 200,
          cellRenderer: (params) => {
            if (params.value === '最低价') {
              return params.value
            } else {
              return `${params.data.minRateValue}${params.value}`
            }
          }
        }
      ]
    }
  },
  computed: {
    language() {
      return this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
    }
  }
}
</script>
<style lang="scss">
</style>

